import * as React from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import diyLightTheme = require('diy/material-ui/diyLightTheme');
import $ = require('jquery');
import {Content, computeContentWidth} from './Content';
import {Sidebar, computeSidebarWidth} from './Sidebar';
import {Limitations, Mode as LimitationsMode} from './Limitations';
import {Category} from '../data';

interface ContainerProps {
    categories: Category[];
    initialCategory: Category;
    columnsNo: number;
    showSidebar: boolean;
    limitationsMode: LimitationsMode;
}

interface ContainerState {
    selectedCategory: Category;
    scrolledCategory: Category;
}

export const computeContainerWidth = (columnsNo: number, showSidebar: boolean) => {
    return computeContentWidth(columnsNo) +
        (showSidebar ? computeSidebarWidth() : 0);
};

export class Container extends React.Component<ContainerProps, ContainerState> {
    private contentWrapper: HTMLElement;

    constructor(props: ContainerProps, context: any) {
        super(props, context);

        this.state = {
            selectedCategory: props.initialCategory,
            scrolledCategory: props.initialCategory
        };
    }

    render() {
        return (
            <MuiThemeProvider muiTheme={diyLightTheme}>
            <div className="container">
                <Limitations mode={this.props.limitationsMode}/>
                <div className="content-wrapper" ref={ref => this.contentWrapper = ref}>
                    {this.props.showSidebar ?
                    <Sidebar categories={this.props.categories}
                        activeCategory={this.state.selectedCategory}
                        onCategorySelect={this.onCategoryChange} />
                    : null }
                    <Content categories={this.props.categories}
                        activeCategory={this.state.scrolledCategory}
                        onScroll={this.onCategoryChange}
                        columnsNo={this.props.columnsNo} />
                </div>
            </div>
            </MuiThemeProvider>
        );
    }

    componentDidMount() {
        this.refreshLimitations();
    }

    componentDidUpdate(prevProps: ContainerProps, prevState: ContainerState) {
        if (this.props.limitationsMode !== prevProps.limitationsMode) {
            this.refreshLimitations();
        }
    }

    private refreshLimitations() {
        this.toggleLimitations(this.props.limitationsMode === LimitationsMode.Maximum);
    }

    private toggleLimitations(disable: boolean) {
         if (disable) {
            $(this.contentWrapper).loadingBox({
                useOverlay: true,
                hideLoader: true
            }).show();
        } else {
            $(this.contentWrapper).loadingBox().remove();
        }
    }

    private onCategoryChange = (category: Category) => {
        this.setState({
            selectedCategory: category,
            scrolledCategory: category
        } as ContainerState);
    };
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/site-admin/section-selector/components/Container.tsx
 **/